import {
  admcsmDeleteRequest,
  admcsmGetRequest,
  admcsmPostRequest,
  admcsmPutRequest
} from "../dataProvider";

export default class AdmcsmUtilService {
  async get(api, config) {
    let response = await admcsmGetRequest(api, config);
    return response;
  }

  async delete(api, config) {
    let response = await admcsmDeleteRequest(api, config);
    return response;
  }

  async post(api, data, config) {
    let response = await admcsmPostRequest(api, data, config);
    return response;
  }

  async put(api, data, config) {
    let response = await admcsmPutRequest(api, data, config);
    return response;
  }
}
